<template>
<div class="footercon">
    <div class="footer">
        <div class="fl">
            <div class="item">
                <span>郑州方程世纪数码信息技术有限公司 版权所有 2017</span>
                &nbsp;&nbsp;
                <a href="https://beian.miit.gov.cn/">豫ICP备17014713号-1</a>
                &nbsp;&nbsp;
                <a href="1600911161674898.png">营业执照</a>
            </div>
            <div class="item">hangzhouleier@126.com</div>
            <div class="item">0371-60989810 60989820</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }
}
</script>

<style lang="scss" scoped>
.footercon {
    position: relative;
    padding: 30px 0;
    background: #161616;
    color: #ccc;
    font-size: 12px;

    a {
        color: #ccc;
        font-size: 12px;
        text-decoration: none;
    }

    .footer {
        width: 1120px;
        margin: 0 auto;

        &::after {
            display: block;
            visibility: hidden;
            height: 0;
            content: ' ';
            clear: both;
        }
    }
}

.fl {
    float: left;
}

.fr {
    float: right;
}

.item {
    width: 100%;
    text-align: left;
    height: 22px;
    line-height: 22px;
}
</style>
